import React from "react";
import "../styles/mobilesectionsummary.css";

const MobileSectionSummary = ({
    quesData,
    subcats,
    attemptedques,
    correctques
}) => {

    return (

        <section className="mss-section">

            <h2 className="mss-heading">
                Sectional Performance
            </h2>

            {

                subcats.map((chapter,index)=>{

                    const totalQuestions =
                        chapter.length;

                    const attempted =
                        attemptedques.find(
                            x=>x[0]===chapter[0]
                        );

                    const correct =
                        correctques.find(
                            x=>x[0]===chapter[0]
                        );

                    return(

                        <SectionCard

                            key={index}

                            chapter={chapter[0]}

                            total={totalQuestions}

                            totalQuestionsInTest={quesData.length}

                            attempted={
                                attempted
                                ?attempted.length
                                :0
                            }

                            score={
                                correct
                                ?correct.length
                                :0
                            }

                        />

                    );

                })

            }

        </section>

    );

};

const SectionCard = ({
    chapter,
    total,
    totalQuestionsInTest,
    attempted,
    score
})=>{

    return(

        <div className="mss-card">

            <h3 className="mss-title">

                {chapter}

            </h3>

            <Progress
                label="Total Questions"
                value={total}
                total={totalQuestionsInTest}
                type="total"
            />

            <Progress
                label="Attempted"
                value={attempted}
                total={total}
                type="attempt"
            />

            <Progress
                label="Correct"
                value={score}
                total={total}
                type="score"
            />

        </div>

    );

};

const Progress = ({
    label,
    value,
    total,
    type
})=>{

    const percent =
        total===0
        ?0
        :(value/total)*100;

    return(

        <div className="mss-progress">

            <div className="mss-progress-header">

                <span>

                    {label}

                </span>

                <strong>

                    {value}

                </strong>

            </div>

            <div className="mss-track">

                <div

                    className={`mss-fill ${type}`}

                    style={{

                        width:`${percent}%`

                    }}

                />

            </div>

        </div>

    );

};

export default MobileSectionSummary;